/**
 * Handles the arguments sent to `fetch`
 * to be a single object.
 *
 * @param  {Array} args: list of arguments
 * @return {Object}
 */
export default function handleMultipleArgs(args) {
  // eslint-disable-next-line
  let [url, options] = args;
  if (typeof url === 'string') {
    options = Object.assign({url}, options);
  } else options = url;
  return options;
}
